<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP" id="ch5"> </p>
<p class="CN"><span epub:type="pagebreak" id="pg_18" title="18"><span href="#/xhtml/contents#c_ch5" title="Link target outside of Sample"><span class="ePub-B">SAM</span></span></span></p>
<p class="CO">You live on Cherry Street.</p>
<p class="TX">It’s a poem. It’s a haiku. I want to tattoo the words on my forehead.</p>
<p class="TX">You stand in the slit between the opaque ivory curtains. Your hand snakes up to rub the back of your white, slender neck. The light pools in your hair, gathers along the sharp lines of your collarbones. You wear a wifebeater, yoga pants. I train my binoculars on the tight peaks of your nipples, erect beneath the thin, white cotton.</p>
<p class="TX">You are even better than I imagined.</p>
<p class="TX">I move the binoculars up to your face. I’m not a pervert, a Peeping Tom.</p>
<p class="TX">I am Romeo, gazing up at Juliet by moonlight.</p>
<p class="TX">And yes, okay, so I’m crouched in a urine-scented alley. That doesn’t make my mission any less noble.</p>
<p class="TX">To study you. Understand you. Observe you in your natural habitat.</p>
<p class="TX">You lean over and grab something from the table beside the couch. A glass of wine. It’s the color of blood. I bet you drink brooding, inky Malbecs, Kate. I bet you deliberate for long minutes before stretching out your long, white fingers and seizing the right <span epub:type="pagebreak" id="pg_19" title="19">bottle. Your taste is impeccable. Now your plush, pink lips fasten around the glass. You take a long sip. That wine sat in some barrel in southwestern France for years, just waiting in darkness for your tongue; now it unfolds on your taste buds, smooth as butter.</span></p>
<p class="TX">You put the glass down and stare out the window.</p>
<p class="TX">Even from here, I feel the weight of your stare. The sadness you keep in those eyes, shadows stored behind the light. Your eyes have seen things. They know things. I feel my throat closing; my binoculars tremble.</p>
<p class="TX">“Hey! What are you doing back there?” A sharp nasal voice cuts through my vigil.</p>
<p class="TX">I turn and see a hooded figure looming just beyond the alley. His glasses glimmer in the streetlight. Not a thug, then, just a hipster looking to do the right thing. Neighborhood security.</p>
<p class="TX">“Thinking about buying.” It’s an automatic response. When questioned, behave like a spoiled prick. You’d be surprised at the number of people who leave you alone if they think your dad’s lawyers can make their life hell.</p>
<p class="TX">“Yeah?” As predicted, the man before me deflates. He thought he was being a hero, stopping a pervert. If I’m just a venture capitalist, my value as an interesting anecdote plummets. “Which one?”</p>
<p class="TX">“House across the street.”</p>
<p class="TX">He looks puzzled. “Didn’t know she was selling. I mean yeah, they split, but I figured she’d hold on to the place.”</p>
<p class="TX">“Insider tip.” My pompous voice makes me shiver. I smirk like an asshole.</p>
<p class="TX">“Well, good luck, I guess.” He looks around. “Not a bad neighborhood. Quiet.”</p>
<p class="TX">“Thanks, man.”</p>
<p class="TX">He chuckles. “Thought you were, you know, stalking someone.”</p>
<p class="TX">We both laugh. <span class="ePub-I">As if</span>.</p>
<p class="TX">He leaves.</p>
<p class="TX"><span epub:type="pagebreak" id="pg_20" title="20">I’m not a threat to you, Kate. I’m watching over you. Biding my time. Waiting for the right moment.</span></p>
<p class="TX">You appear in the window again, a worried frown creasing your forehead. I travel down your body with my binoculars. You’re everything I’ve waited for and more.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter5.vue?0dbaccfc